import * as $ from "jquery"
import * as creditCard from "./credit-card"

export type ValidAccountParams = DirectDebitParams | (CreditCardParams & {method: "CreditCard"})
export type Error = {method: "error", title: string, error: string}
export type AccountParams = ValidAccountParams | Error

type DirectDebitParams = {
	accountName: string,
	accountNumber: string,
	bsb: string,
	method: "DirectDebit"
}

const getDirectDebitParams = function (): DirectDebitParams {
	return {
		method: "DirectDebit",
		accountName:   window.ivt.jQuery("[name='directEntryAccountName']").val(),
		accountNumber: window.ivt.jQuery("[name='directEntryAccountNumber']").val(),
		bsb:           window.ivt.jQuery("[name='directEntryBSB1']").val() + window.ivt.jQuery("[name='directEntryBSB2']").val()
	}
}

const addValidationRules = function (paymentMethod: PaymentMethodType) {
	window.ivt.jQuery(".required").removeClass("required")
	window.ivt.jQuery("#" + paymentMethod).find("input:visible").addClass("required")
}

const checkFormForErrors = function (paymentMethod: PaymentMethodType, form: JQuery): Error|undefined {
	const isCreditCardPayment = paymentMethod == "CreditCard"

	addValidationRules(paymentMethod)

	form.validate()

	const paymentError = (error: string): Error => ({method: 'error', title: 'Invalid Payment Information', error})

	if (!form.valid()) {
		return paymentError("Please ensure all " + (isCreditCardPayment ? "credit card" : "direct debit") + " fields are filled out")
	}

	if (isCreditCardPayment && !creditCard.isCreditCardValid()) {
		return paymentError("The credit card number you have entered is not valid")
	}

	if (isCreditCardPayment && !creditCard.isCreditCardCvvValid()) {
		return paymentError("The credit card CVV you have entered is not valid. It should be " + creditCard.requiredCvvDigits() + " digits long")
	}

	if (isCreditCardPayment && !creditCard.isCreditCardExpiryValid()) {
		return paymentError("Please enter a current expiry date")
	}

	return undefined
}

type PaymentMethodType = 'CreditCard' | 'DirectDebit'

export const getFormValues = (form: JQuery): AccountParams => {
	const paymentMethod: PaymentMethodType = window.ivt.jQuery('[name=method]').val()

	const errors = checkFormForErrors(paymentMethod, form)

	if(errors) {
		return errors
	}

	return paymentMethod == "CreditCard" ?  creditCard.getCreditCardParams() :  getDirectDebitParams()
}



// WEBPACK FOOTER //
// ./src/paymentgateway/payment-methods-tabs.ts